import { render } from "./factsComponent.vue?vue&type=template&id=6acc384c"
import script from "./factsComponent.vue?vue&type=script&lang=js"
export * from "./factsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__